import { Controller } from '@hotwired/stimulus'

const VDOCK_SELECTOR =
  'input[name="ehub_transport_dockings_dock_form[load_instructions][vdocks][]"]:checked'

export default class extends Controller {
  static targets = ['loadPreviewFrame']

  connect() {
    const vdockIds = this.checkedVdockIds()
    if (vdockIds.length > 0) this.updatePreviewBaseUrl(vdockIds)
  }

  changeLoadPreviewUrl(_event) {
    this.updatePreviewUrl(this.checkedVdockIds())
  }

  updatePreviewUrl(vdockIds) {
    this.appendVdocksToUrl(this.loadPreviewFrameTarget, 'src', vdockIds)
  }

  updatePreviewBaseUrl(vdockIds) {
    // On initial load, turbo_frame_controller.ts hasn't run yet so we update the wrapper dataset instead of frame.src
    const wrapper = this.loadPreviewFrameTarget.closest('[data-ui-turbo-frame-id-value]')
    this.appendVdocksToUrl(wrapper.dataset, 'uiTurboFrameLazyLoadUrlValue', vdockIds)
  }

  checkedVdockIds() {
    return Array.from(this.element.querySelectorAll(VDOCK_SELECTOR)).map(cb => cb.value)
  }

  appendVdocksToUrl(obj, key, vdockIds) {
    const url = new URL(obj[key], window.location.origin)
    url.searchParams.delete('vdocks[]')
    vdockIds.forEach(id => url.searchParams.append('vdocks[]', id))
    obj[key] = url.href
  }
}
